import Vue from 'vue';
import VueYouTubeEmbed from 'vue-youtube-embed';
import VueGtag from 'vue-gtag';
import VueApexCharts from 'vue-apexcharts';
import VTitle from 'v-title';
import VueCarousel from 'vue-carousel';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import {
  SENTRY_DSN, SENTRY_DOMAIN, SENTRY_ENABLED, SENTRY_SAMPLE_RATE, HOST_NAME,
} from '@/config';
import router from '@/router';
import VueRouter from 'vue-router';
import { resetBreadcrumbs } from '@/common/utils/breadcrumbs';
import CripNotice from 'crip-vue-notice';
import App from './App.vue';
import store from './common/store';
import gtmConfig from './gtm';
import './registerServiceWorker';
import i18n from './i18n';


if (SENTRY_ENABLED) {
  Sentry.init({
    Vue,
    dsn: SENTRY_DSN,
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: [SENTRY_DOMAIN, /^\//],
      }),
    ],
    tracesSampleRate: SENTRY_SAMPLE_RATE, // Percentage (between 0 and 1) of errors sent to Sentry;
    environment: HOST_NAME,
  });
}

Vue.config.productionTip = false;


Vue.use(CripNotice, {
  duration: 3.5,
  styles: { bottom: '60px', right: '15px' },
  icons: {
    info: 'fa fa-info-circle',
    success: 'fa fa-check-circle',
    warning: 'fa fa-exclamation-circle',
    error: 'fa fa-times-circle',
    close: 'fa fa-times',
  },
});

router.beforeEach(async (to, from, next) => {
  resetBreadcrumbs();
  if (localStorage.getItem('auth-token') !== null) {
    // There is an auth token stored in the local storage;
    if (!store.getters.user.isAuthenticated) {
      await store.dispatch('refreshUser');
      next();
    } else {
      next();
    }
  } else {
    next();
  }
});

Vue.use(VueApexCharts);
Vue.use(VueYouTubeEmbed);
Vue.use(VTitle);
Vue.use(VueGtag, gtmConfig, router);
Vue.use(VueCarousel);
Vue.use(VueRouter);


Vue.component('apexchart', VueApexCharts);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
